module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-900italic.76a86801.ttf";